import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "More steampunk",
  "description": "",
  "published": "2007-03-02T00:00:00.000Z",
  "redirect_from": ["/blog/more-steampunk/swizec/273"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today the lovely `}<a parentName="p" {...{
        "href": "http://forum.darkness.com/index.php"
      }}>{`darkness fora`}</a>{` blessed me with means to procuring some very nice steampunk links. There was `}<a parentName="p" {...{
        "href": "http://forum.darkness.com/index.php"
      }}><em parentName="a">{`Steampunk`}</em></a>{` - the new steampunk magazine, `}<a parentName="p" {...{
        "href": "http://www.brassgoggles.co.uk/brassgoggles/"
      }}><em parentName="a">{`Brass Goggles`}</em></a>{` - a very nice and frequently updated blog aobut this stuff and `}<em parentName="p"><a parentName="em" {...{
          "href": "http://www.lycettebros.com/automata/index.html"
        }}>{`The Modern Compendum of Miniature Automata`}</a></em>{` - which I can't quite describe, but you should check it out because it's fun.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      